function parseSettings(settings) {
    if (!settings) {
      return null;
    }

    if (typeof settings === 'object'){
      return settings;
    }

    const obj = {};
    settings.map((item) => {
      obj[item.type] = item.value;
    });
    return obj;
  }
  
  export default parseSettings;
  